import script from "./AdminActivityManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminActivityManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminActivityManager.vue?vue&type=style&index=0&id=01c0d473&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c0d473"]])

export default __exports__